class TaxCheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.isLoading = false;
    this.quoteValid = false;
    this.savedApiResponse = null;
    this.onTaxCalculated = null;

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleCartEvent = this.handleCartEvent.bind(this);
    this.handleProvinceSelectChange = this.handleProvinceSelectChange.bind(this);
    this.handlePersonTypeChange = this.handlePersonTypeChange.bind(this);
    this.handleExemptChange = this.handleExemptChange.bind(this);
  }

  // Validação de CPF
  validateCPF(cpf) {
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    
    let sum = 0;
    for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
    let digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cpf.charAt(9))) return false;
    
    sum = 0;
    for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
    digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cpf.charAt(10))) return false;
    
    return true;
  }

  // Validação de CNPJ
  validateCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]/g, '');
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;
    
    let size = cnpj.length - 2;
    let numbers = cnpj.substring(0, size);
    let digits = cnpj.substring(size);
    let sum = 0;
    let pos = size - 7;
    
    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }
    
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;
    
    size = size + 1;
    numbers = cnpj.substring(0, size);
    sum = 0;
    pos = size - 7;
    
    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }
    
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1))) return false;
    
    return true;
  }

  // Validação de Inscrição Estadual (validação básica)
  validateIE(ie, province) {
    ie = ie.replace(/[^\d]/g, '');
    // Validação mínima: deve ter entre 8 e 14 dígitos
    if (ie.length < 8 || ie.length > 14) return false;
    // Não pode ser tudo igual
    if (/^(\d)\1+$/.test(ie)) return false;
    return true;
  }



  connectedCallback() {
    this.isLoggedIn = this.dataset.loggedIn === 'true';
    this.loginUrl = this.dataset.loginUrl || '/account/login';
    this.customerEmail = this.dataset.email || '';
    this.customerProvince = this.dataset.province || '';
    this.priceTable = this.dataset.priceTable || 'AAA';
    
    // Configura callback se fornecido via atributo
    if (this.dataset.onTaxCalculated && typeof window[this.dataset.onTaxCalculated] === 'function') {
      this.onTaxCalculated = window[this.dataset.onTaxCalculated];
    }

    this.render();

    this.$module = this.shadowRoot.querySelector('.tax-module');
    this.$fields = this.shadowRoot.querySelector('.tax-fields');
    this.$button = this.shadowRoot.querySelector('button');
    this.$personType = this.shadowRoot.querySelector('select[name="person-type"]');
    this.$cnpj = this.shadowRoot.querySelector('input[name="cnpj"]');
    this.$ie = this.shadowRoot.querySelector('input[name="ie"]');
    this.$exempt = this.shadowRoot.querySelector('input[name="exempt"]');
    this.$ieField = this.shadowRoot.querySelector('[data-ie-field]');
    this.$docLabel = this.shadowRoot.querySelector('[data-doc-label]');
    this.$docInput = this.shadowRoot.querySelector('[data-doc-input]');
    this.$emailHidden = this.shadowRoot.querySelector('input[name="email"]');
    this.$provinceHidden = this.shadowRoot.querySelector('input[name="province"]');
    this.$provinceWrapper = this.shadowRoot.querySelector('[data-province-select]');
    this.$provinceSelect = this.shadowRoot.querySelector('select[name="province-select"]');
    this.$error = this.shadowRoot.querySelector('.tax-error');

    // preenche email e estado, se vierem do Liquid
    if (this.customerEmail && this.$emailHidden) {
      this.$emailHidden.value = this.customerEmail;
    }
    if (this.customerProvince && this.$provinceHidden) {
      this.$provinceHidden.value = this.customerProvince;
      if (this.$provinceWrapper) this.$provinceWrapper.classList.add('hidden');
    } else {
      // sem endereço: mostra select de estados
      if (this.$provinceWrapper) this.$provinceWrapper.classList.remove('hidden');
    }

    this.$button.addEventListener('click', this.handleButtonClick);

    const cartEventName = this.dataset.cartEvent;
    if (cartEventName) {
      window.addEventListener(cartEventName, this.handleCartEvent);
    }

    // Listener para sincronização com PDP via custom events - será adicionado após carregamento
    this.handleCustomerTaxDataChanged = this.handleCustomerTaxDataChanged.bind(this);

    this.addFieldEventListeners();
    this.loadSavedCustomerTaxData();
  }

  addFieldEventListeners() {
    if (!this.$button) return;
    this.$personType.addEventListener('change', this.handlePersonTypeChange);
    this.$cnpj.addEventListener('input', this.handleFieldChange);
    this.$cnpj.addEventListener('blur', this.handleFieldBlur); // Sincroniza ao sair do campo
    this.$ie.addEventListener('input', this.handleFieldChange);
    this.$ie.addEventListener('blur', this.handleFieldBlur); // Sincroniza ao sair do campo
    this.$exempt.addEventListener('change', this.handleExemptChange);
    this.$provinceSelect.addEventListener('change', this.handleProvinceSelectChange);
  }

  removeFieldEventListeners() {
    if (!this.$button) return;
    this.$personType.removeEventListener('change', this.handlePersonTypeChange);
    this.$cnpj.removeEventListener('input', this.handleFieldChange);
    this.$cnpj.removeEventListener('blur', this.handleFieldBlur);
    this.$ie.removeEventListener('input', this.handleFieldChange);
    this.$ie.removeEventListener('blur', this.handleFieldBlur);
    this.$exempt.removeEventListener('change', this.handleExemptChange);
    this.$provinceSelect.removeEventListener('change', this.handleProvinceSelectChange);
  }

  disconnectedCallback() {
    this.$button?.removeEventListener('click', this.handleButtonClick);
    this.$personType?.removeEventListener('change', this.handlePersonTypeChange);
    this.$cnpj?.removeEventListener('input', this.handleFieldChange);
    this.$ie?.removeEventListener('input', this.handleFieldChange);
    this.$exempt?.removeEventListener('change', this.handleExemptChange);
    this.$provinceSelect?.removeEventListener('change', this.handleProvinceSelectChange);

    const cartEventName = this.dataset.cartEvent;
    if (cartEventName) {
      window.removeEventListener(cartEventName, this.handleCartEvent);
    }

    // Remove listener de sincronização se foi adicionado
    window.removeEventListener('customer-tax-data-changed', this.handleCustomerTaxDataChanged);
  }

  render() {
    const initialText = this.textContent.trim() || 'Finalizar compra';

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }
        :host * {
          box-sizing: border-box;
        }
        .hidden { display: none !important; }

        .tax-module {
          width: 100%;
        }
        .tax-inner {
          display: flex;
          flex-direction: column;
          gap: 6px;
          background: #fcfcfc;
          border-radius: 8px;
          padding: 8px;
        }

        .tax-fields {
          overflow: hidden;
          max-height: 0;
          opacity: 0;
          transform: translateY(4px);
          transition: all .25s ease;
        }
        .tax-module.open .tax-fields {
          max-height: 380px;
          opacity: 1;
          transform: translateY(0);
          margin-bottom: 4px;
        }

        .tax-row {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-bottom: 6px;
        }
        .tax-field {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 2px;
        }
        .tax-field-with-checkbox {
          position: relative;
        }
        .tax-label {
          font-size: 11px;
          color: #555;
        }
        .tax-input,
        .tax-select {
          width: 100%;
          padding: 6px 8px;
          border-radius: 4px;
          border: 1px solid #ccc;
          font-size: 12px;
          background: #fff;
        }
        .tax-input[disabled] {
          background: #f5f5f5;
          cursor: not-allowed;
          opacity: 0.6;
        }
        .tax-exempt-wrapper {
          display: flex;
          align-items: center;
          gap: 4px;
          position: absolute;
          right: 9px;
          bottom: 4px;
        }
        .tax-exempt-wrapper input[type="checkbox"] {
          width: auto;
          cursor: pointer;
        }
        .tax-exempt-wrapper label {
          font-size: 11px;
          color: #555;
          cursor: pointer;
          user-select: none;
        }
        .tax-note {
          font-size: 11px;
          color: #666;
        }
        .tax-error {
          margin-top: 4px;
          font-size: 11px;
          color: #b00020;
        }

        button {
          width: 100%;
          padding: 10px 16px;
          border-radius: 6px;
          border: none;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          background: #000;
          color: #fff;
          transition: opacity .2s ease, transform .1s ease;
        }
        button[disabled] {
          opacity: .5;
          cursor: default;
        }
        button.loading {
          cursor: wait;
        }
        .loader {
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border: 2px solid rgba(255,255,255,.6);
          border-top-color: transparent;
          margin-right: 8px;
          animation: spin .7s linear infinite;
          vertical-align: middle;
        }
          
        .button--primary {
          font-family: var(--btn-3-font-family);
          font-size: var(--btn-3-font-size);
          font-weight: var(--btn-3-font-weight);
          text-transform: var(--btn-3-text-transform);
          text-align: var(--btn-3-text-align);
          letter-spacing: var(--btn-3-letter-spacing);
          line-height: var(--btn-3-line-height);
          border-radius: var(--btn-3-border-radius);
          border-style: var(--btn-3-border-style);
          border-width: var(--btn-3-border-width);
          padding-top: var(--btn-3-padding-top);
          padding-bottom: var(--btn-3-padding-bottom);
          background: var(--product-action-bg);
          color: var(--product-action-color);
          border-color: var(--product-action-border);
          box-shadow: var(--btn-3-horizontal-length) var(--btn-3-vertical-length)
            var(--btn-3-blur-radius) var(--btn-3-spread) var(--btn-3-all-bg-opacity)
            var(--btn-3-inset);
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>

      <div class="tax-module">
        <div class="tax-inner">
          <div class="tax-fields">
            <div class="tax-row">
              <div class="tax-field">
                <label class="tax-label" for="tax-person-type">Comprar como</label>
                <select class="tax-select" id="tax-person-type" name="person-type">
                  <option value="legal">Pessoa Jurídica</option>
                  <option value="physical">Pessoa Física</option>
                </select>
              </div>

              <div class="tax-field">
                <label class="tax-label" for="tax-cnpj" data-doc-label>CNPJ</label>
                <input class="tax-input" id="tax-cnpj" name="cnpj" placeholder="00.000.000/0000-00" data-doc-input />
              </div>
              <div class="tax-field tax-field-with-checkbox" data-ie-field>
                <label class="tax-label" for="tax-ie">Inscrição Estadual</label>
                <input class="tax-input" id="tax-ie" name="ie" placeholder="Inscrição Estadual" />
                <div class="tax-exempt-wrapper">
                  <input type="checkbox" id="tax-exempt" name="exempt" />
                  <label for="tax-exempt">Isento</label>
                </div>
              </div>

              <div class="tax-field hidden" data-province-select>
                <label class="tax-label" for="tax-province">Estado</label>
                <select class="tax-select" id="tax-province" name="province-select">
                  <option value="">Selecione o estado</option>
                  <option value="AC">AC</option><option value="AL">AL</option>
                  <option value="AP">AP</option><option value="AM">AM</option>
                  <option value="BA">BA</option><option value="CE">CE</option>
                  <option value="DF">DF</option><option value="ES">ES</option>
                  <option value="GO">GO</option><option value="MA">MA</option>
                  <option value="MT">MT</option><option value="MS">MS</option>
                  <option value="MG">MG</option><option value="PA">PA</option>
                  <option value="PB">PB</option><option value="PR">PR</option>
                  <option value="PE">PE</option><option value="PI">PI</option>
                  <option value="RJ">RJ</option><option value="RN">RN</option>
                  <option value="RS">RS</option><option value="RO">RO</option>
                  <option value="RR">RR</option><option value="SC">SC</option>
                  <option value="SP">SP</option><option value="SE">SE</option>
                  <option value="TO">TO</option>
                </select>
              </div>

              <!-- hidden fields preenchidos via Liquid / JS -->
              <input type="hidden" name="email" />
              <input type="hidden" name="province" />
            </div>

            <p class="tax-note" style="display: none">
              Usamos esses dados para calcular impostos e emitir nota.  
              Alterar CPF/CNPJ/IE, o estado ou o carrinho exige nova validação.
            </p>
            <div class="tax-error" aria-live="polite"></div>
          </div>

          <button class="button button--primary" type="button">
            <span class="label">${initialText}</span>
          </button>
        </div>
      </div>
    `;
  }

  get endpoint() {
    return this.dataset.endpoint || '/api/v1/create-draft-order';
  }

  setOpen(open) {
    if (!this.$module || !this.$button) return;
    this.$module.classList.toggle('open', open);
    const labelEl = this.$button.querySelector('.label');
    if (labelEl) {
      labelEl.textContent = open ? 'Continuar' : 'Validação de compra';
    }
  }

  setLoading(loading) {
    this.isLoading = loading;
    if (!this.$button) return;

    const labelEl = this.$button.querySelector('.label');
    if (loading) {
      this.$button.classList.add('loading');
      this.$button.setAttribute('disabled', 'disabled');
      if (!this.$button.querySelector('.loader')) {
        const loader = document.createElement('span');
        loader.className = 'loader';
        this.$button.prepend(loader);
      }
      if (labelEl) labelEl.textContent = 'Calculando taxas...';
    } else {
      this.$button.classList.remove('loading');
      this.$button.removeAttribute('disabled');
      const isOpen = this.$module?.classList.contains('open');
      if (labelEl) labelEl.textContent = isOpen ? 'Continuar' : 'Validação de compra';
      const loader = this.$button.querySelector('.loader');
      if (loader) loader.remove();
    }
  }

  setError(message) {
    if (!this.$error) return;
    this.$error.textContent = message || '';
  }

  loadSavedCustomerTaxData() {
    try {
      // Marca flag para evitar disparo de eventos durante carregamento
      this._isLoading = true;
      this._initialLoad = true; // Marca que está no carregamento inicial
      
      // Remove listeners para evitar eventos durante atualização programática
      this.removeFieldEventListeners();
      
      const raw = localStorage.getItem('customer_tax_data');
      if (!raw) {
        this._isLoading = false;
        this._initialLoad = false;
        this.addFieldEventListeners();
        return;
      }
      const data = JSON.parse(raw);
      
      // Restaura tipo de pessoa (sempre atualiza, tem valor padrão)
      if (this.$personType) {
        const personType = data.personType || 'legal'; // Padrão: Pessoa Jurídica
        this.$personType.value = personType;
        const isPhysical = personType === 'physical';
        
        // Atualiza labels manualmente sem disparar eventos
        if (this.$docLabel) {
          this.$docLabel.textContent = isPhysical ? 'CPF' : 'CNPJ';
        }
        if (this.$docInput) {
          this.$docInput.placeholder = isPhysical ? '000.000.000-00' : '00.000.000/0000-00';
        }
        if (this.$ieField) {
          this.$ieField.classList.toggle('hidden', isPhysical);
        }
      }
      
      // Restaura documento (CPF/CNPJ) - sempre, mesmo se vazio
      if (this.$cnpj) this.$cnpj.value = data.cnpj || '';
      
      // Restaura inscrição estadual - sempre, mesmo se vazio
      if (this.$ie) this.$ie.value = data.ie || '';
      
      // Restaura checkbox de isento E atualiza estado do campo
      if (data.exempt !== undefined && this.$exempt) {
        this.$exempt.checked = data.exempt;
        // Atualiza campo IE manualmente
        if (data.exempt && this.$ie) {
          this.$ie.value = '';
          this.$ie.setAttribute('disabled', 'disabled');
        } else if (this.$ie) {
          this.$ie.removeAttribute('disabled');
        }
      }
      
      // Restaura província se não vier do Liquid
      if (data.province && !this.customerProvince && this.$provinceSelect) {
        this.$provinceSelect.value = data.province;
        this.$provinceHidden.value = data.province;
      }
      
      // Abre o formulário se tiver dados
      if (data.cnpj || data.ie) {
        this.setOpen(true);
      }
      
      // Verifica se há resposta da API salva e se o carrinho ainda é válido
      this.loadSavedApiResponse();
      
      // Remove flag de loading e readiciona listeners
      this._isLoading = false;
      this.addFieldEventListeners();
      
      // Marca carregamento concluído e adiciona listener de sincronização
      this._initialLoad = false;
      
      // Adiciona listener de sincronização APÓS carregamento completo
      window.addEventListener('customer-tax-data-changed', this.handleCustomerTaxDataChanged);
    } catch (e) {
      console.warn('Erro ao carregar dados fiscais salvos', e);
      this._isLoading = false;
      this._initialLoad = false;
      this.addFieldEventListeners();
      window.addEventListener('customer-tax-data-changed', this.handleCustomerTaxDataChanged);
    }
  }

  saveCustomerTaxData(silent = false) {
    if (this._isSaving) return; // Previne recursão
    
    const personType = this.$personType?.value;
    const cnpj = this.$cnpj?.value || ''; // NÃO usar trim - preserva valor digitado
    const ie = this.$ie?.value || '';
    const exempt = this.$exempt?.checked;
    const province = this.$provinceHidden?.value || '';
    
    try {
      this._isSaving = true;
      
      localStorage.setItem('customer_tax_data', JSON.stringify({ 
        personType,
        cnpj, 
        ie,
        exempt,
        province
      }));
      
      // Dispara evento customizado APENAS se:
      // 1. Não for uma sincronização recebida
      // 2. Não for um save silencioso (durante digitação)
      if (!this._receivingSync && !silent) {
        window.dispatchEvent(new CustomEvent('customer-tax-data-changed', {
          detail: { personType, cnpj, ie, exempt, province }
        }));
      }
      
      setTimeout(() => {
        this._isSaving = false;
      }, 0);
    } catch (e) {
      console.warn('Erro ao salvar dados fiscais', e);
      this._isSaving = false;
    }
  }

  saveApiResponse(cartHash, apiResponse) {
    try {
      localStorage.setItem('tax_api_response', JSON.stringify({
        cartHash,
        response: apiResponse,
        timestamp: Date.now()
      }));
    } catch (e) {
      console.warn('Erro ao salvar resposta da API', e);
    }
  }

  async loadSavedApiResponse() {
    try {
      const raw = localStorage.getItem('tax_api_response');
      if (!raw) return;
      
      const saved = JSON.parse(raw);
      const { hash: currentCartHash } = await this.fetchCartData();
      
      // Verifica se o hash do carrinho ainda é o mesmo
      if (saved.cartHash === currentCartHash) {
        this.quoteValid = true;
        this.savedApiResponse = saved.response;
        console.log('Resposta da API restaurada:', saved.response);
        
        // Chama callback se disponível
        this.triggerTaxCalculatedCallback(saved.response);
      } else {
        // Carrinho mudou, remove a resposta salva
        this.clearApiResponse();
      }
    } catch (e) {
      console.warn('Erro ao carregar resposta da API', e);
    }
  }

  clearApiResponse() {
    try {
      localStorage.removeItem('tax_api_response');
      this.savedApiResponse = null;
      this.quoteValid = false;
      
      // Chama callback com null para limpar as taxas no HTML
      this.triggerTaxCalculatedCallback(null);
    } catch (e) {
      console.warn('Erro ao limpar resposta da API', e);
    }
  }

  triggerTaxCalculatedCallback(response) {
    if (typeof this.onTaxCalculated === 'function') {
      try {
        this.onTaxCalculated(response);
      } catch (e) {
        console.warn('Erro ao executar callback onTaxCalculated:', e);
      }
    }
    
    // Dispatch custom event para listeners externos
    this.dispatchEvent(new CustomEvent('tax-calculated', {
      bubbles: true,
      composed: true,
      detail: response
    }));
  }

  /**
   * Obtém a resposta atual da API se válida
   * @returns {Object|null} DraftOrderResponse com os campos:
   *   - draftOrderId: string
   *   - invoiceUrl: string
   *   - message: string
   *   - blipsPayment: boolean
   *   - totalTaxes: number
   */
  getTaxResponse() {
    return this.quoteValid ? this.savedApiResponse : null;
  }

  checkProductTaxCache(cartProducts) {
    try {
      const raw = localStorage.getItem('product_tax_data');
      if (!raw) {
        console.log('[TAX-MODULE] Cache vazio - nenhum produto com taxa calculada');
        return null;
      }
      
      const productTaxData = JSON.parse(raw);
      let totalTaxes = 0;
      let allProductsHaveCache = true;
      
      console.log('[TAX-MODULE] Verificando cache para', cartProducts.length, 'produtos do carrinho');
      
      for (const product of cartProducts) {
        // Extrai o variant ID numérico do GID
        const variantIdMatch = product.variantId.match(/\/(\d+)$/);
        if (!variantIdMatch) continue;
        
        const variantId = variantIdMatch[1];
        
        // Procura por qualquer produto que tenha esse variant
        let found = false;
        for (const key in productTaxData) {
          const cachedData = productTaxData[key];
          if (cachedData.variantId === variantId) {
            console.log('[TAX-MODULE] ✓ Cache encontrado para variant', variantId, '- Taxa:', cachedData.totalTaxes);
            totalTaxes += (cachedData.totalTaxes || 0) * product.quantity;
            found = true;
            break;
          }
        }
        
        if (!found) {
          console.log('[TAX-MODULE] ✗ Cache NÃO encontrado para variant', variantId);
          allProductsHaveCache = false;
          break;
        }
      }
      
      if (allProductsHaveCache) {
        console.log('[TAX-MODULE] ✓ TODOS os produtos têm cache - Total de taxas:', totalTaxes);
        return { totalTaxes };
      }
      
      console.log('[TAX-MODULE] Alguns produtos sem cache - requisição necessária');
      return null;
    } catch (e) {
      console.warn('[TAX-MODULE] Erro ao verificar cache:', e);
      return null;
    }
  }

  async fetchCartData() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return { hash: null, products: [] };

      const cart = await res.json();
      const signature = cart.items.map(i => `${i.id}:${i.quantity}`).join('|');
      let hash = 0;
      for (let i = 0; i < signature.length; i++) {
        hash = (hash * 31 + signature.charCodeAt(i)) | 0;
      }

      // Busca as tags de cada produto usando o handle
      const productsWithTags = await Promise.all(
        cart.items.map(async (item) => {
          let hasEquipamentosTag = false;
          
          try {
            // Busca os dados completos do produto usando o handle
            const productRes = await fetch(`/products/${item.handle}.js`);
            if (productRes.ok) {
              const productData = await productRes.json();
              // Verifica se tem a tag "Equipamentos"
              if (productData.tags && Array.isArray(productData.tags)) {
                hasEquipamentosTag = productData.tags.some(
                  tag => tag.toLowerCase() === 'equipamentos'
                );
              }
            }
          } catch (e) {
            console.warn(`Erro ao buscar tags do produto ${item.handle}:`, e);
          }

          return {
            variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
            quantity: item.quantity,
            priceTable: this.priceTable,
            consult: hasEquipamentosTag
          };
        })
      );

      return { hash: String(hash), products: productsWithTags };
    } catch (e) {
      console.warn('Erro ao buscar carrinho', e);
      return { hash: null, products: [] };
    }
  }

  invalidateQuote() {
    this.quoteValid = false;
    this.clearApiResponse();
    this.setError('');
    
    // Limpa storage de taxas de produtos (sincroniza com PDP)
    try {
      localStorage.removeItem('product_tax_data');
      
      // Dispara evento para notificar componentes da PDP
      window.dispatchEvent(new CustomEvent('product-tax-data-cleared'));
    } catch (e) {
      console.warn('Erro ao limpar dados de taxas:', e);
    }
  }

  handleFieldChange() {
    // Ignora se estiver carregando dados ou recebendo sincronização
    if (this._isLoading || this._receivingSync) return;

    this.invalidateQuote();

    // NÃO salva durante digitação - apenas ao sair do campo (blur)
    // Isso evita salvar valores parciais e conflitos com outros módulos
  }

  handleFieldBlur(e) {
    if (this._isLoading || this._receivingSync) return;
    
    // Quando campo perde foco: sincroniza com outro módulo
    clearTimeout(this.saveTimeout);
    this.saveCustomerTaxData(false); // Salva E dispara evento de sincronização
  }

  handleProvinceSelectChange() {
    if (this._isLoading || this._receivingSync) return;
    
    const value = this.$provinceSelect.value;
    this.$provinceHidden.value = value;
    
    // Salva dados imediatamente ao trocar estado
    clearTimeout(this.saveTimeout);
    this.saveCustomerTaxData();
    this.invalidateQuote();
  }

  handlePersonTypeChange() {
    if (this._isLoading || this._receivingSync) return;
    
    const personType = this.$personType.value;
    const isPhysical = personType === 'physical';

    // Atualiza label e placeholder do campo de documento
    if (this.$docLabel) {
      this.$docLabel.textContent = isPhysical ? 'CPF' : 'CNPJ';
    }
    if (this.$docInput) {
      this.$docInput.placeholder = isPhysical ? '000.000.000-00' : '00.000.000/0000-00';
    }

    // Mostra/esconde campo de Inscrição Estadual
    if (this.$ieField) {
      this.$ieField.classList.toggle('hidden', isPhysical);
    }

    // Limpa o campo de IE e desmarca checkbox quando mudar para pessoa física
    if (isPhysical) {
      if (this.$ie) {
        this.$ie.value = '';
        this.$ie.removeAttribute('disabled'); // Garante que não fique travado
      }
      if (this.$exempt) this.$exempt.checked = false;
    } else {
      // Para PJ, garante que IE está habilitado se não for isento
      if (this.$ie && !this.$exempt?.checked) {
        this.$ie.removeAttribute('disabled');
      }
    }

    // Salva dados fiscais imediatamente ao trocar tipo de pessoa
    clearTimeout(this.saveTimeout);
    this.saveCustomerTaxData();
    this.invalidateQuote();
  }

  handleExemptChange() {
    if (this._isLoading || this._receivingSync) return;
    
    const isExempt = this.$exempt.checked;

    if (isExempt) {
      if (this.$ie) {
        this.$ie.value = '';
        this.$ie.setAttribute('disabled', 'disabled');
      }
    } else {
      if (this.$ie) {
        this.$ie.removeAttribute('disabled');
      }
    }

    // Salva dados imediatamente ao mudar checkbox isento
    clearTimeout(this.saveTimeout);
    this.saveCustomerTaxData();
  }

  async handleCartEvent() {
    // Verifica se o carrinho mudou comparando o hash
    try {
      const saved = localStorage.getItem('tax_api_response');
      if (saved) {
        const { cartHash: savedHash } = JSON.parse(saved);
        const { hash: currentHash } = await this.fetchCartData();
        
        if (savedHash !== currentHash) {
          console.log('Carrinho mudou, invalidando cotação');
          this.invalidateQuote();
        }
      }
    } catch (e) {
      console.warn('Erro ao verificar mudança do carrinho', e);
    }
  }

  handleCustomerTaxDataChanged(e) {
    // Evento disparado pela PDP quando dados fiscais mudam
    if (!e.detail || this._isSaving || this._receivingSync) {
      return;
    }
    
    try {
      this._isLoading = true;
      this._receivingSync = true; // Marca que está recebendo sincronização
      
      // Remove listeners para evitar eventos durante atualização programática
      this.removeFieldEventListeners();
      
      const data = e.detail;
      
      // Atualiza campos manualmente sem disparar eventos
      if (this.$personType && data.personType) {
        this.$personType.value = data.personType;
        const isPhysical = data.personType === 'physical';
        
        // Atualiza labels manualmente
        if (this.$docLabel) {
          this.$docLabel.textContent = isPhysical ? 'CPF' : 'CNPJ';
        }
        if (this.$docInput) {
          this.$docInput.placeholder = isPhysical ? '000.000.000-00' : '00.000.000/0000-00';
        }
        if (this.$ieField) {
          this.$ieField.classList.toggle('hidden', isPhysical);
        }
      }
      
      // Atualiza CPF/CNPJ (sempre sincroniza o valor, mesmo vazio)
      if (this.$cnpj) this.$cnpj.value = data.cnpj || '';
      if (this.$ie) this.$ie.value = data.ie || '';
      
      if (this.$exempt && data.exempt !== undefined) {
        this.$exempt.checked = data.exempt;
        // Atualiza estado do campo IE manualmente
        if (data.exempt && this.$ie) {
          this.$ie.value = '';
          this.$ie.setAttribute('disabled', 'disabled');
        } else if (this.$ie) {
          this.$ie.removeAttribute('disabled');
        }
      }
      
      if (this.$provinceSelect && data.province && !this.customerProvince) {
        this.$provinceSelect.value = data.province;
        this.$provinceHidden.value = data.province;
      }
      
      this._isLoading = false;
      this._receivingSync = false; // Remove flag após processar
      
      // Readiciona listeners
      this.addFieldEventListeners();
      
      // Invalida cotação pois dados mudaram
      this.invalidateQuote();
    } catch (err) {
      console.warn('[TAX-MODULE] Erro ao sincronizar dados da PDP:', err);
      this._isLoading = false;
      this.addFieldEventListeners();
      this._receivingSync = false;
    }
  }

  buildLoginRedirectUrl() {
    // se o Liquid já montou com return_url, usa direto
    if (this.loginUrl) return this.loginUrl;

    const current = window.location.pathname + window.location.search + '#cart=open';
    return `/customer_identity/login?return_to=${encodeURIComponent(current)}`;
  }

  async handleButtonClick() {
    if (this.isLoading) return;

    // precisa estar logado
    if (!this.isLoggedIn) {
      window.location.href = this.buildLoginRedirectUrl();
      return;
    }

    const isOpen = this.$module.classList.contains('open');
    const email = this.$emailHidden.value.trim();
    const cnpj = this.$cnpj.value.trim();
    const ie = this.$ie.value.trim();
    const province = this.$provinceHidden.value.trim();
    const personType = this.$personType.value;
    const isPhysical = personType === 'physical';
    const isExempt = this.$exempt.checked;

    // 1º clique: só abre o box
    if (!isOpen) {
      this.setOpen(true);
      if (!cnpj) {
        const docType = isPhysical ? 'CPF' : 'CNPJ';
        this.setError(`Preencha ${docType}${!isPhysical ? ' e/ou Inscrição Estadual' : ''} para continuar.`);
        this.$cnpj.focus();
      } else if (!province) {
        this.setError('Selecione o estado para continuar.');
        if (this.$provinceWrapper && !this.$provinceWrapper.classList.contains('hidden')) {
          this.$provinceSelect.focus();
        }
      }
      return;
    }

    // 2º clique: valida tudo
    if (!email) {
      this.setError('Não foi possível obter seu e-mail. Atualize a página e tente novamente.');
      return;
    }
    if (!cnpj) {
      const docType = isPhysical ? 'CPF' : 'CNPJ';
      this.setError(`Preencha ${docType} para continuar.`);
      this.$cnpj.focus();
      return;
    }
    if (!isPhysical && !isExempt && !ie) {
      this.setError('Preencha a Inscrição Estadual ou marque como Isento para continuar.');
      this.$ie.focus();
      return;
    }
    if (!province) {
      this.setError('Selecione o estado para continuar.');
      if (this.$provinceWrapper && !this.$provinceWrapper.classList.contains('hidden')) {
        this.$provinceSelect.focus();
      }
      return;
    }

    // Valida CPF/CNPJ
    if (isPhysical) {
      if (!this.validateCPF(cnpj)) {
        this.setError('CPF inválido. Verifique o número digitado.');
        this.$cnpj.focus();
        return;
      }
    } else {
      if (!this.validateCNPJ(cnpj)) {
        this.setError('CNPJ inválido. Verifique o número digitado.');
        this.$cnpj.focus();
        return;
      }
    }
    
    // Valida IE se não for isento
    if (!isPhysical && !isExempt && ie) {
      if (!this.validateIE(ie, province)) {
        this.setError('Inscrição Estadual inválida. Verifique o número digitado.');
        this.$ie.focus();
        return;
      }
    }

    this.setError('');
    await this.createDraftOrderAndRedirect({ email, cnpj, ie, province });
  }

  async createDraftOrderAndRedirect({ email, cnpj, ie, province }) {
    this.setLoading(true);
    this.setError('');

    try {
      const { hash: cartHash, products } = await this.fetchCartData();

      console.log('[TAX-MODULE] ==== INÍCIO DO PROCESSO DE CHECKOUT ====');
      console.log('[TAX-MODULE] Cart Hash:', cartHash);
      console.log('[TAX-MODULE] Produtos no carrinho:', products.length);

      // Verifica se já existe uma resposta válida salva (cotação anterior)
      if (this.quoteValid && this.savedApiResponse) {
        console.log('[TAX-MODULE] ✓ Usando cotação válida anterior (quoteValid=true)');
        this.saveCustomerTaxData();
        
        // Chama callback antes de redirecionar
        this.triggerTaxCalculatedCallback(this.savedApiResponse);
        
        window.location.href = this.savedApiResponse.invoiceUrl;
        return;
      }
      
      // Verifica se todos os produtos do carrinho já têm taxas calculadas no cache da PDP
      const cachedTaxes = this.checkProductTaxCache(products);
      if (cachedTaxes && cachedTaxes.totalTaxes !== undefined) {
        console.log('[TAX-MODULE] ✓✓✓ USANDO CACHE DA PDP - Evitando requisição à API');
        console.log('[TAX-MODULE] Total de taxas do cache:', cachedTaxes.totalTaxes);
        
        // Cria resposta mock usando dados do cache
        const mockResponse = {
          draftOrderId: 'cached',
          invoiceUrl: '/checkout', // URL genérica, será substituída pela API se necessário
          message: 'Taxas calculadas a partir do cache',
          blipsPayment: true,
          totalTaxes: cachedTaxes.totalTaxes / 100, // Converte centavos para reais
          fromCache: true
        };
        
        this.quoteValid = true;
        this.saveCustomerTaxData();
        this.saveApiResponse(cartHash, mockResponse);
        this.triggerTaxCalculatedCallback(mockResponse);
        
        // Como é cache, ainda precisa fazer a requisição real para obter invoiceUrl
        // mas pode fazer em background ou validar primeiro
        console.log('[TAX-MODULE] Fazendo requisição para obter invoiceUrl...');
      } else {
        console.log('[TAX-MODULE] ✗ Cache incompleto ou inexistente - fazendo requisição à API');
      }

      const body = {
        email,
        client: {
          province,
          provinceTaxCode: '', // pode mapear depois se precisar
          company: cnpj,
          ie
        },
        products,
        cartHash
      };
      
      console.log('[TAX-MODULE] >>> Fazendo requisição POST para:', this.endpoint);
      console.log('[TAX-MODULE] Payload:', JSON.stringify(body, null, 2));
      
      const res = await fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      if (!res.ok) {
        console.error('[TAX-MODULE] ✗ Erro na requisição - Status:', res.status);
        throw new Error(`Erro HTTP ${res.status}`);
      }

      const data = await res.json();
      console.log('[TAX-MODULE] ✓ Resposta da API recebida:', data);
      
      // Valida estrutura da DraftOrderResponse
      if (!data || !data.invoiceUrl || !data.draftOrderId) {
        throw new Error('Resposta inválida da API.');
      }

      this.quoteValid = true;
      this.saveCustomerTaxData();
      this.saveApiResponse(cartHash, data);
      
      console.log('[TAX-MODULE] ✓ Dados salvos - Redirecionando para:', data.invoiceUrl);
      
      // Chama callback com os dados da resposta
      this.triggerTaxCalculatedCallback(data);
      
      window.location.href = data.invoiceUrl;
    } catch (error) {
      console.error('[TAX-MODULE] ✗✗✗ ERRO ao criar draft order:', error);
      this.setError('Não foi possível validar os impostos. Tente novamente.');
      this.quoteValid = false;
    } finally {
      this.setLoading(false);
    }
  }
}

if (!customElements.get('tax-checkout-button')) {
  customElements.define('tax-checkout-button', TaxCheckoutButton);
}

// Abrir carrinho automaticamente quando retornar do login
document.addEventListener('DOMContentLoaded', function() {
  const hash = window.location.hash;
  if (hash === '#cart=open') {
    // Adicionar classe para abrir o carrinho sidebar
    document.body.classList.add('cart-sidebar-show');
    
    // Limpar o hash da URL sem recarregar a página
    if (history.replaceState) {
      history.replaceState(null, null, window.location.pathname + window.location.search);
    }
  }
});

/**
 * EXEMPLO DE USO - Callback para manipular taxas no HTML
 * 
 * 1. Via atributo data (recomendado):
 * 
 * <tax-checkout-button
 *   data-on-tax-calculated="handleTaxCalculated"
 *   ...outros atributos...
 * ></tax-checkout-button>
 * 
 * <script>
 *   window.handleTaxCalculated = function(response) {
 *     if (response) {
 *       // Resposta bem sucedida - exibe as taxas
 *       console.log('Draft Order ID:', response.draftOrderId);
 *       console.log('Invoice URL:', response.invoiceUrl);
 *       console.log('Message:', response.message);
 *       console.log('Blips Payment:', response.blipsPayment);
 *       console.log('Total Taxes:', response.totalTaxes);
 *       
 *       // Exemplo: Atualizar elemento no HTML
 *       const taxElement = document.getElementById('cart-taxes');
 *       if (taxElement) {
 *         taxElement.textContent = `Impostos: R$ ${response.totalTaxes.toFixed(2)}`;
 *         taxElement.style.display = 'block';
 *       }
 *     } else {
 *       // Resposta foi limpa (carrinho mudou ou invalidado)
 *       const taxElement = document.getElementById('cart-taxes');
 *       if (taxElement) {
 *         taxElement.style.display = 'none';
 *       }
 *     }
 *   };
 * </script>
 * 
 * 2. Via Event Listener:
 * 
 * <script>
 *   document.querySelector('tax-checkout-button').addEventListener('tax-calculated', function(event) {
 *     const response = event.detail;
 *     if (response) {
 *       // Manipular resposta...
 *     }
 *   });
 * </script>
 * 
 * 3. Via método público:
 * 
 * <script>
 *   const taxButton = document.querySelector('tax-checkout-button');
 *   const currentResponse = taxButton.getTaxResponse();
 *   if (currentResponse) {
 *     console.log('Total de taxas atual:', currentResponse.totalTaxes);
 *   }
 * </script>
 * 
 * ESTRUTURA DA RESPOSTA (DraftOrderResponse):
 * {
 *   draftOrderId: "gid://shopify/DraftOrder/123456",
 *   invoiceUrl: "https://checkout.shopify.com/...",
 *   message: "Sucesso ao calcular impostos",
 *   blipsPayment: true,
 *   totalTaxes: 125.50
 * }
 */